import { render } from "./McpDocs.vue?vue&type=template&id=f9d752c6&scoped=true"
import script from "./McpDocs.vue?vue&type=script&lang=js"
export * from "./McpDocs.vue?vue&type=script&lang=js"

import "./McpDocs.vue?vue&type=style&index=0&id=f9d752c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9d752c6"]])

export default __exports__